import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { environment } from 'src/environments/environment';
@Injectable({ providedIn: 'root' })
export class CandidateAttendanceService {

  constructor(private apiService: ApiService) {


  }
  addCandidateAttendance(batchId, jobRole, payLoad) {
    const URL = `${environment.ToTServiceURL}/api/tot-toa/v1/pmkvy/attendence?jobRole=${jobRole}&batchId=${batchId}`;
    return this.apiService.put(URL, payLoad)
  }

  getBatchAttendence(batchId, jobRole, from, to) {
    const URL = `${environment.ToTServiceURL}/api/tot-toa/v1/pmkvy/attendence?jobRole=${jobRole}&batchId=${batchId}&from=${from}&to=${to}`;
    return this.apiService.get(URL)
  }

  getAebaseAttendance(batchId, isCssm, stateCode, filterObj?, isSkillHub?, isNipun?, isMohuaAebase?) {

    let paramObj = {}
    paramObj['isCssm'] = isCssm;
    paramObj['stateCode'] = stateCode;
    if (filterObj && filterObj.candidateId) {
      paramObj['candidateId'] = filterObj.candidateId
    }
    if (filterObj && filterObj.attendenceStatus) {
      paramObj['attendenceStatus'] = filterObj.attendenceStatus
    }
    if (isNipun === "yes") {
      paramObj = {};
      if (filterObj && filterObj.candidateId) {
        paramObj['candidateId'] = filterObj.candidateId
      }
      if (filterObj && filterObj.attendenceStatus) {
        paramObj['attendenceStatus'] = filterObj.attendenceStatus
      }
      const URL = `${environment.userServiceUrl}/api/batch/v1/GetAebaseAttendance?batchId=${batchId}&isNipun=yes&pageNo=1&itemsPerPage=50`;
      return this.apiService.get(URL, paramObj);
    } else if (isMohuaAebase === 'yes') {
      const URL = `${environment.userServiceUrl}/api/batch/v1/GetAebaseAttendance?batchId=${batchId}&isMohuaAebase=yes&pageNo=1&itemsPerPage=50`;
      return this.apiService.get(URL, paramObj);
    } else {
      const URL = `${environment.userServiceUrl}/api/batch/v1/GetAebaseAttendance?batchId=${batchId}&isSkillHub=${isSkillHub}&pageNo=1&itemsPerPage=50`;
      return this.apiService.get(URL, paramObj);
    }

  }

  getTableHeader(jobRole, batchId, canId) {
    const URL = `${environment.ToTServiceURL}/api/tot-toa/v1/pmkvy/attendence/dates?jobRole=${jobRole}&batchId=${batchId}&canId=${canId}`;
    return this.apiService.get(URL);
  }


  getBatchById(batchId) {
    const URL = `${environment.userServiceUrl}/api/batch/v1/batch/${batchId}`;
    return this.apiService.get(URL);
  }

  submitAttendance(payLoad) {
    const URL = `${environment.ToTServiceURL}/api/tot-toa/v1/pmkvy/attendence`;
    return this.apiService.patch(URL, payLoad)

  }

  uploadSupportingDocument(payLoad) {
    const URL = `${environment.ToTServiceURL}/api/tot-toa/v1/pmkvy/attendence/supportingdocs`;
    return this.apiService.patch(URL, payLoad);
  }

  getholidayDay(batchId) {
    const URL = `${environment.ToTServiceURL}/api/tot-toa/v1/pmkvy/attendence/sessions?batchId=${batchId}`;
    return this.apiService.get(URL);
  }
}
